import React from 'react'
import { Link } from 'react-router-dom'
import { useLanguage } from '../i18n/LanguageContext'
import MetaTags from '../components/MetaTags'

export default function ForbiddenPage() {
  const { t, getPageUrl } = useLanguage()

  return (
    <div className="bg-slate-50 min-h-[70vh] flex items-center justify-center py-20 px-4">
      <MetaTags
        title={t.forbidden.metaTitle}
        description={t.forbidden.metaDesc}
      />

      <div className="max-w-md w-full text-center bg-white p-8 sm:p-10 rounded-2xl border border-slate-200 shadow-sm space-y-6">
        <div className="w-20 h-20 bg-amber-50 text-amber-600 rounded-2xl flex items-center justify-center text-3xl font-extrabold mx-auto">
          403
        </div>

        <h1 className="text-2xl font-extrabold text-slate-900">
          {t.forbidden.title}
        </h1>

        <p className="text-slate-600 text-sm leading-relaxed">
          {t.forbidden.desc}
        </p>

        <div className="pt-2 flex flex-col gap-3">
          <Link
            to={getPageUrl('home')}
            className="w-full bg-sky-500 hover:bg-sky-600 text-white font-bold py-3 px-4 rounded-none shadow transition-colors flex items-center justify-center gap-2"
          >
            <i className="fa-solid fa-house text-sm"></i>
            <span>{t.forbidden.homeBtn}</span>
          </Link>
        </div>
      </div>
    </div>
  )
}
